import React, { Fragment } from 'react'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

import ItemArticuloModalOferta from './ItemArticuloModalOferta'

// router
import { withRouter } from 'react-router-dom'
import useModalArticuloOferta from './useModalArticuloOferta'

const ModalArticulosOferta = ({ setCodigoArticulo }) => {
    const {
        articulos,
        totalRegister,
        totalPage,
        page,
        nextPage,
        previousPage,
        onChangeArticulo,
        handleSearchKeyPress,
        onChangeSearchCriteria,
        searchCriteria,
        query,
        handleOpenModal,
        handleCloseModal,
        handleAnimationEnd
    } = useModalArticuloOferta()

    return (
        <Fragment>
            <button
                type="button"
                className="btn btn-outline-info"
                data-toggle="modal"
                data-target="#modalArticuloOferta"
                onClick={handleOpenModal}
            >
                <FontAwesomeIcon icon={faSearch} />
            </button>

            <div
                className="modal fade w-100"
                id="modalArticuloOferta"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="modalArticuloOfertaTitle"
                aria-hidden="true"
                onClick={handleCloseModal}
                onAnimationEnd={handleAnimationEnd}
                data-keyboard="false"
            >
                <div
                    className="modal-dialog modal-dialog-scrollable modal-lg"
                    role="document"
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5
                                className="modal-title text-center w-100"
                                id="modalArticuloOfertaTitle"
                            >
                                Articulos
                            </h5>
                        </div>
                        <div className="modal-body">
                            {/* Radio buttons para criterio de búsqueda */}
                            <div className="mb-4">
                                <h6 className="mb-3 text-muted fw-semibold">Seleccionar criterio de búsqueda:</h6>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="d-flex justify-content-center gap-4">
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="searchCriteriaOferta"
                                                    id="searchByNombreOferta"
                                                    value="nombre"
                                                    checked={searchCriteria === 'nombre'}
                                                    onChange={onChangeSearchCriteria}
                                                />
                                                <label className="form-check-label fw-medium" htmlFor="searchByNombreOferta">
                                                    <span role="img" aria-label="Nombre">📝</span> Nombre
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="searchCriteriaOferta"
                                                    id="searchByCodigoOferta"
                                                    value="codigo"
                                                    checked={searchCriteria === 'codigo'}
                                                    onChange={onChangeSearchCriteria}
                                                />
                                                <label className="form-check-label fw-medium" htmlFor="searchByCodigoOferta">
                                                    <span role="img" aria-label="Código">🔢</span> Código
                                                </label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="searchCriteriaOferta"
                                                    id="searchByCodigoBarraOferta"
                                                    value="codigoBarra"
                                                    checked={searchCriteria === 'codigoBarra'}
                                                    onChange={onChangeSearchCriteria}
                                                />
                                                <label className="form-check-label fw-medium" htmlFor="searchByCodigoBarraOferta">
                                                    <span role="img" aria-label="Código de Barra">📊</span> Código de Barra
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Input de búsqueda */}
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder={`Buscar por ${searchCriteria === 'nombre' ? 'nombre' : searchCriteria === 'codigo' ? 'código' : 'código de barra'}...`}
                                    value={query}
                                    onChange={onChangeArticulo}
                                    onKeyDown={handleSearchKeyPress}
                                />
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="addon-wrapping"
                                    >
                                        <FontAwesomeIcon icon={faSearch} />
                                    </span>
                                </div>
                            </div>
                            {/* Inicio de paginador */}
                            <div className="d-flex w-100 justify-content-between align-items-center mb-2" style={{ minHeight: '56px' }}>
                                <div className="bd-highlight">
                                    <button
                                        className="btn btn-outline-info"
                                        onClick={() => previousPage()}
                                        aria-label="Previous"
                                        type="button"
                                    >
                                        <span aria-hidden="true">
                                            &laquo; Anterior
                                        </span>
                                    </button>
                                </div>
                                <div className="p-2 bd-highlight mt-1">
                                    Registros: {totalRegister} | Pagina actual:{' '}
                                    {page + 1} | Total páginas : {totalPage}
                                </div>
                                <div className="bd-highlight">
                                    <button
                                        className="btn btn-outline-info"
                                        onClick={() => nextPage()}
                                        aria-label="Next"
                                        type="button"
                                    >
                                        <span aria-hidden="true">
                                            Siguiente &raquo;
                                        </span>
                                    </button>
                                </div>
                            </div>
                            <table className="table mt-3 text-center">
                                <thead className="thead-dark">
                                    <tr>
                                        <th scope="col">Codigo</th>
                                        <th scope="col">Nombre</th>
                                        <th scope="col">Precio</th>
                                        <th scope="col">Seleccionar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {articulos.map((articulo) => (
                                        <ItemArticuloModalOferta
                                            key={parseInt(articulo.id)}
                                            articulo={articulo}
                                            setCodigoArticulo={
                                                setCodigoArticulo
                                            }
                                        />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-dismiss="modal"
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(ModalArticulosOferta)
